// Where the Data Graph lives: a tab of the operator console (Advanced Config) since 2026-10-30.
// Consultants set data graphs up there; nothing in the main app links to it. Every in-module
// link builds on these, so the mount point is written once.
export const GRAPH_BASE = '/advanced-config/data-graph';

const seg = (v) => encodeURIComponent(v);

/** One data source: its named data graphs. */
export const sourcePath = (dataSourceId) => `${GRAPH_BASE}/${seg(dataSourceId)}`;

/** One data graph's explorer: tables, links, its key and hop limit. */
export const graphPath = (dataSourceId, graphId) => `${sourcePath(dataSourceId)}/graphs/${seg(graphId)}`;

/** One Salesforce object within a data graph. */
export const objectPath = (dataSourceId, graphId, objectName) => `${graphPath(dataSourceId, graphId)}/object/${seg(objectName)}`;
